import React, { useCallback, useRef, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

/**
 * Displays an optional description at the top of a space
 * Supports HTML content for rich formatting
 * Intercepts internal link clicks to use React Router instead of full navigation
 */
const SpaceDescription = ({ description }) => {
  const navigate = useNavigate();
  const containerRef = useRef(null);

  // Intercept link clicks to prevent full page navigation
  const handleClick = useCallback((e) => {
    const link = e.target.closest('a');
    if (!link) return;

    const href = link.getAttribute('href');
    if (!href) return;

    // External links - open in new tab
    if (href.startsWith('http://') || href.startsWith('https://') || href.startsWith('//')) {
      e.preventDefault();
      window.open(href, '_blank', 'noopener,noreferrer');
      return;
    }

    // Internal links - use React Router
    if (href.startsWith('/')) {
      e.preventDefault();
      navigate(href);
      return;
    }
  }, [navigate]);

  // Attach click handler to container
  useEffect(() => {
    const container = containerRef.current;
    if (!container) return;

    container.addEventListener('click', handleClick);
    return () => container.removeEventListener('click', handleClick);
  }, [handleClick]);

  if (!description) return null;
  
  return (
    <div className="bg-gray-800/50 border-b border-gray-700/50 px-6 py-3">
      <div 
        ref={containerRef}
        className="text-gray-300 text-sm prose prose-sm prose-invert max-w-none
                   prose-a:text-blue-400 prose-strong:text-white prose-em:text-gray-200"
        dangerouslySetInnerHTML={{ __html: description }}
      />
    </div>
  );
};

export default SpaceDescription;


